var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcBusca(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "958A3B89-0644-4249-ADAF-CF2F497C1793") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Maio---indique-um-amigo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "indique-v2-2",
    transform: "translate(-755.000000, -377.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ic-busca",
    transform: "translate(755.000000, 377.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "bound",
    fillOpacity: 0,
    fill: "#D8D8D8",
    transform: "translate(12.000000, 12.000000) scale(1, -1) translate(-12.000000, -12.000000) ",
    points: "24 0 0 0 0 24 24 24"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#FF6A58",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    cx: 12,
    cy: 12,
    r: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22,
    y1: 22,
    x2: 17.65,
    y2: 17.65,
    id: "Path",
    stroke: "#FF6A58",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBusca);
export default __webpack_public_path__ + "static/media/ic-busca.56561e0381dd2ac0166389fd3346d8d8.svg";
export { ForwardRef as ReactComponent };